<template>


  <div class="container">
      <h3 class="heading">المحافظة</h3>

      <form @submit.prevent="postinfo">

  <div class="mb-3 input-in-con">
    <div v-if="err">
  <div v-if="err.name"  class="alert alert-danger" role="alert"> {{ err.name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">اسم المحافظة</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="ادخل اسم المحافظة " v-model="formdata.name">
</div>
<div class="flex">
  
  
  
<div class="mb-3 input-in-con ">    
  <label for="exampleFormControlInput1" class="form-label">رقم المحافظة</label>
  <div v-if="err">
  <div v-if="err.numder"  class="alert alert-danger" role="alert"> {{ err.numder[0]}}</div>
</div>
  <input type="text" class="form-control  ltr" id="exampleFormControlInput1" placeholder="ادخل رقم المحافظة" v-model="formdata.numder">
</div>
</div>
<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>



</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name: "EditGov",
props:['id'],
 data(){
  return{
    formdata:{
      name: '',
      numder: '',
    },
          err:null

    
  }
},
mounted(){
      // Get gov 
       fetch(geturl()+"provinec/",{
      headers: {"Content-Type": "application/json"},
       })
       .then(res => res.json())
       .then(data => {this.formdata = data})
       
       // Get specific gov
       this.formdata = this.formdata.filter((e)=>{
           return e.id == this.id
       })
},
methods: {
    postinfo(){
  
      
    fetch(geturl()+"provinec/"+this.id+"/", {
         method: "PUT",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(this.formdata)
      })
      .then(res => res.json())
      .then(data =>{ 
              if(data.error)
      this.err = data.error.details
      else
            this.$router.push({name:'ViewGov' })
      })
    },
    
}
}

</script>

<style>

</style>